import { styled } from 'stitches.config'

export const CarouselRoot = styled('div', {
  position: 'relative',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '$2',
  width: '100%',
  '& button': {
    padding: '0 !important',
    backgroundColor: 'transparent',
    margin: '0',
    zIndex: '1',
  },
  '& button:disabled': {
    pointerEvents: 'none',
    opacity: '0.5',
    cursor: 'not-allowed',
  },
  '@bp2': {
    padding: '$6 $2',
    '& button.shiftTop': {
      transform: 'translateY(-5rem)',
    },
  },
  variants: {
    padding: {
      large: {
        padding: '5rem $2',
        '@bp2': {
          padding: '10rem $2',
        },
      },
      small: {
        padding: '0',
        '@bp2': {
          padding: '$11 $2 $2 $2',
        },
      },
      noMobile: {
        padding: '0',
        '@bp2': {
          padding: '5rem $2',
        },
      },
    },
  },
})

export const CarouselContainer = styled('div', {
  display: 'flex',
  alignItems: 'stretch',
  flexWrap: 'nowrap !important',
  position: 'relative',
  padding: '0',
  margin: '0',
  variants: {
    scroll: {
      x: {
        overflow: 'scroll !important',
        scrollbarColor: '#FF4620 #57100B !important',
        position: 'relative',
        width: '100%',
        gap: '$4',
        scrollSnapType: 'x mandatory',
        paddingTop: '$6',
        '& *': {
          padding: '0',
        },
        '@bp2': {
          overflow: 'hidden !important',
        },
      },
      none: {
        overflow: 'hidden',
      },
    },
    width: {
      eighty: {
        '@bp2': {
          width: '80%',
        },
      },
    },
  },
})

export const CarouselItem = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: '0 0 auto !important',
  alignItems: 'center',
  justifyContent: 'flex-start',
  gap: '$2',
  padding: '$2',
  position: 'relative',
  width: '100%',
  zIndex: '1',
  transition: 'transform 0.6s ease 0s',
  '& p': {
    padding: '$1',
  },
  variants: {
    scroll: {
      x: {
        scrollSnapAlign: 'start',
        paddingBottom: '1rem',
        '&::after': {
          content: '',
          position: 'absolute',
          bottom: '1.25px',
          left: '0',
          backgroundColor: '$quaternary-200',
          height: '1px',
          width: '110%',
        },
        '@bp2': {
          '&::after': {
            height: '0',
          },
        },
      },
    },
    mobileAlign: {
      left: {
        '& p': {
          textAlign: 'left',
          padding: '0 1rem',
          '@bp2': {
            padding: '0',
          },
        },
      },
    },
    imageRadius: {
      none: {
        '& img': {
          borderRadius: '0 !important',
        },
      },
    },
    width: {
      half: {
        width: '100%',
        '@bp2': {
          width: '50%',
        },
      },
      third: {
        width: '100%',
        '@bp2': {
          width: '33%',
        },
      },
      fourth: {
        width: '100%',
        '@bp2': {
          width: '25%',
        },
      },
    },
    alignItems: {
      start: {
        alignItems: 'flex-start',
      },
    },
    slide: {
      '1': {
        transform: 'translateX(-100%)',
      },
      '2': {
        transform: 'translateX(-200%)',
      },
      '3': {
        transform: 'translateX(-300%)',
      },
      '4': {
        transform: 'translateX(-400%)',
      },
      '5': {
        transform: 'translateX(-500%)',
      },
      '6': {
        transform: 'translateX(-600%)',
      },
      '7': {
        transform: 'translateX(-700%)',
      },
      '8': {
        transform: 'translateX(-800%)',
      },
      '9': {
        transform: 'translateX(-900%)',
      },
      '10': {
        transform: 'translateX(-1000%)',
      },
    },
  },
})
